.jc{right:0.25rem;}